import { catchError } from 'rxjs/operators';
import { of as observableOf, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// import { test_data_small, test_data_large } from './usage-reporting.service.mock_data';

// interface UsageReportingCourseWiskerData {
//   x: number;    // Numeric position on the x axis
//   l: number;    // Low end of the bottom candlestick
//   o: number;    // bottom of the box
//   c: number;    // top of the box
//   h: number;    // High end of the top candlestick
// }

interface UsageReportingSeriesData {
  name: string;
  dataPoints: number[];
}

interface UsageReportingNotebookUsageDataset {
  label: string;
  dataPoints: number[];
}

interface UsageReportingstats {
  annual_unique_logins: number;
  course_notebooks: UsageReportingNotebookUsageDataset[];
  course_notebooks_labels: {
    [Key: string]: string[];
  };
  course_summary: {
    name: string[];
    unique_ids: number[];
  };
  hours: {
    labels: string[];
    dataPoints: number[];
  };
  monthly_labels: string[];
  monthly_displays: string[];
  monthly_total_logins: UsageReportingSeriesData;
  monthly_unique_logins: UsageReportingSeriesData;
  monthly_nb_starts: UsageReportingSeriesData;
  notebook_types: {
    labels: string[];
    dataPoints: number[];
  };
  // course_whiskers: {
  //   labels: string[];
  //   data: UsageReportingCourseWiskerData[];
  // };
}

export interface UsageReportingData {
  scope: string;
  customer: string;
  message: string;
  raw_usage: UsageReportingstats;
}

export interface IUsageReportingService {
  getUsageReporting(): Observable<UsageReportingData | null>;
}

@Injectable()
export class UsageReportingService implements IUsageReportingService {
  readonly apiUrl: string = '/api/usagestats/';
  usageData$: Observable<UsageReportingData | null>;

  constructor(private _http: HttpClient) {}

  getUsageReporting(): Observable<UsageReportingData | null> {
    // return observableOf(test_data_large);
    return this._http.get<UsageReportingData | null>(this.apiUrl).pipe(
      catchError(error => {
        console.log('in catch: ' + JSON.stringify(error));
        return observableOf(null);
      }),
    );
  }
}
